{
	"id": 7503,
	"moduleNumber": 3,
	"slug": "module-3",
	"kgNodeId": "module-3",
	"title": "The Professional Educator and the Student",
	"subtitle": "Practice ethical decisions around student welfare, boundaries, and educator-student trust.",
	"type": "lesson",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"sourceStatus": "extracted_from_source_documents",
	"summary": "Module 3 focuses on educator-student ethical tensions through two scenarios: Mr. Arnold's interactions with students and Coach Buckner's response to a student-athlete situation. Learners practice recognizing boundary concerns, balancing student welfare with role obligations, and choosing MCEE-aligned actions.",
	"estimatedDurationMinutes": 45,
	"activityCount": 3,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	},
	"learningObjectives": [
		"Analyze a scenario to differentiate how dispositional and regulatory frameworks influence decision making.",
		"Evaluate competing tensions to select actions aligned with ethical principles.",
		"Apply MCEE-aligned decision criteria to resolve ethical scenarios."
	],
	"flow": [
		"Module landing and outline.",
		"Scenario 1: Mr. Arnold.",
		"Perspectives for Scenario 1.",
		"Reflect, Explore, Review, and Analysis for Scenario 1.",
		"Ethical Situations: Potential Ethical Outcomes.",
		"Scenario 2: Coach Buckner.",
		"Perspectives for Scenario 2.",
		"Reflect, Explore, Review, and Analysis for Scenario 2.",
		"Five-question end-of-module knowledge check."
	],
	"scenarios": [
		{
			"id": "module-3-mr-arnold",
			"title": "Scenario 1: Mr. Arnold",
			"summary": "Mr. Arnold's classroom interactions, after-school invitation, and student communications create ethical questions about boundaries, favoritism, role clarity, and student welfare."
		},
		{
			"id": "module-3-coach-buckner",
			"title": "Scenario 2: Coach Buckner",
			"summary": "Coach Buckner faces tensions around student safety, athlete expectations, fairness, reporting responsibilities, and the educator's obligation to protect student welfare."
		}
	],
	"ethicalSituations": [
		"Bullying",
		"Boundary Concern",
		"Student Confidentiality",
		"Team Participation",
		"Peer Pressure",
		"Academic Fairness",
		"Reporting Concern",
		"Student Safety",
		"Parent Communication",
		"Professional Judgment"
	],
	"ethicalPrinciples": [
		"Ensuring Student Welfare",
		"Honoring the Boundaries of Role, Time, and Place",
		"Objectivity and Neutrality Are Maintained",
		"Risk Mitigation",
		"Transparency in Actions and Communications",
		"Code of Ethics for Educators Is Maintained with Fidelity",
		"Integrity of the Profession Is Promoted by the Educator"
	],
	"sources": {
		"curriculum": "../../../../.working/Praxis ProEthics/Content/curriculum/modules/module-3/module.md",
		"primary": "../../../../.working/Praxis ProEthics/Content/Module 3/SCORM/Module 3_Rise and Storyline Version V3_Updated.docx",
		"scorm": "../../../../.working/Praxis ProEthics/Content/Module 3/SCORM/Module 3_Rise and Storyline Version V3_Updated.docx",
		"session": "../../assessment/sessions/module-3.json",
		"itemsDir": "../items/module-3",
		"transcripts": [
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s1_Macbeth_dialogue transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s1p1_Alex Mom_dialogue transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s1p2_Mr_Smith_dialogue transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s1p3_Coach_Buckner_dialogue transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s2_Crossed_Lines_dialogue transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s2p1_Assistant_Coach_dialogue transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s2p2_The_Warning_dialogue transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Dialogue Transcript/m3s2p3_Community_Eyes_dialogue transcript.docx"
		],
		"videos": [
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/Macbeth_Video_Apr20Edited_v2_captioned.mp4",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/m3s1p1_REGEN_Alex_Mom_Final_captioned (2).mp4",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/m3s1p2_REGEN_Mr_Smith_revised_captioned.mp4",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/Coach_Buckner_captioned_trim (1).mp4",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/CroosedLines_LogoRemoved_mar31_captioned (1).mp4",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/m3s2p1_REGEN_Asst_Coach_captioned.mp4",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/m3s2p2_REGEN_Warning_captioned.mp4",
			"../../../../.working/Praxis ProEthics/Content/Module 3/Generated Videos/m3s2p3_REGEN_Community_Eyes_Revisedtranscript1_captioned (1).mp4"
		]
	}
}
